export type Profile = "visionnaire" | "chill" | "stratege" | "ambitieux" | "securitaire";

export interface Answer {
  text: string;
  scores: Partial<Record<Profile, number>>;
}

export interface Question {
  id: number;
  emoji: string;
  question: string;
  answers: Answer[];
}

export const questions: Question[] = [
  {
    id: 1,
    emoji: "💸",
    question: "Quand tu reçois ta paye, tu fais quoi en premier ?",
    answers: [
      { text: "J'épargne immédiatement 🐷", scores: { stratege: 3, securitaire: 2 } },
      { text: "Je file dépenser 🛍️", scores: { chill: 3, ambitieux: 1 } },
      { text: "Je rembourse mes dettes 🧾", scores: { securitaire: 3, stratege: 1 } },
      { text: "Je me paye un resto entre potes 🍔", scores: { chill: 2, visionnaire: 1 } },
    ],
  },
  {
    id: 2,
    emoji: "🧠",
    question: "Quelle phrase te décrit le mieux ?",
    answers: [
      { text: "J'aime quand mon argent travaille pour moi 🏗️💰", scores: { visionnaire: 3, ambitieux: 2 } },
      { text: "La sécurité avant tout 🛡️", scores: { securitaire: 3, stratege: 1 } },
      { text: "Un euro est un euro 🪙", scores: { chill: 2, securitaire: 2 } },
      { text: "Rien à perdre, tout à gagner ! 🎲🔥", scores: { ambitieux: 3, visionnaire: 1 } },
    ],
  },
  {
    id: 3,
    emoji: "🏠",
    question: "Ton niveau de connaissance en investissement immobilier ?",
    answers: [
      { text: "1 — Zéro idée 😅", scores: { chill: 3, securitaire: 1 } },
      { text: "2 🤔", scores: { chill: 2, securitaire: 2 } },
      { text: "3 🙂", scores: { stratege: 2, ambitieux: 1 } },
      { text: "4 😎", scores: { stratege: 3, visionnaire: 2 } },
      { text: "5 — Je gère 🧠📈", scores: { visionnaire: 4, ambitieux: 3, stratege: 2 } },
    ],
  },
  {
    id: 4,
    emoji: "🎁",
    question: "Si demain tu gagnes 1000€, tu fais quoi ?",
    answers: [
      { text: "Épargne 🐷", scores: { securitaire: 3, stratege: 1 } },
      { text: "Shopiiiing 🛍️✨", scores: { chill: 3 } },
      { text: "J'investis sur Ommistack 🏠⚡", scores: { ambitieux: 3, visionnaire: 2 } },
      { text: "Je pars en voyage ! ✈️🌴", scores: { chill: 2, visionnaire: 1 } },
      { text: "J'investis dans l'immobilier 🏢📈", scores: { stratege: 3, ambitieux: 2 } },
    ],
  },
  {
    id: 5,
    emoji: "📅",
    question: "Tu préfères investir combien chaque mois ?",
    answers: [
      { text: "1 à 50€ 🌱", scores: { chill: 2, securitaire: 2 } },
      { text: "51 à 200€ 🔥", scores: { stratege: 2, ambitieux: 1 } },
      { text: "201 à 500€ 💪", scores: { ambitieux: 3, stratege: 1 } },
      { text: "Plus de 500€ 🚀", scores: { visionnaire: 3, ambitieux: 2 } },
    ],
  },
  {
    id: 6,
    emoji: "🎯",
    question: "Quelle est ta principale motivation pour investir ?",
    answers: [
      { text: "Retraite anticipée ⏳🏖️", scores: { stratege: 3, visionnaire: 1 } },
      { text: "Voyager plus ✈️🌍", scores: { chill: 2, ambitieux: 1 } },
      { text: "Liberté financière 🗽💸", scores: { ambitieux: 3, visionnaire: 2 } },
      { text: "Sécurité 🛡️🏠", scores: { securitaire: 3 } },
    ],
  },
  {
    id: 7,
    emoji: "👂",
    question: "En matière d'argent, tu écoutes plutôt…",
    answers: [
      { text: "Personne, je gère 😤", scores: { visionnaire: 2, ambitieux: 2 } },
      { text: "Tes potes 🧑‍🤝‍🧑", scores: { chill: 3 } },
      { text: "Ta famille 👨‍👩‍👧‍👦", scores: { securitaire: 2, stratege: 1 } },
      { text: "Des influenceurs 📱✨", scores: { ambitieux: 2, chill: 1 } },
    ],
  },
  {
    id: 8,
    emoji: "💡",
    question: "L'investissement idéal pour toi, c'est…",
    answers: [
      { text: "Fun et stimulant 🎢🔥", scores: { ambitieux: 3, visionnaire: 1 } },
      { text: "Simple, sans effort 😌✅", scores: { chill: 3, securitaire: 1 } },
      { text: "Risque minimum 🧊🛡️", scores: { securitaire: 3, stratege: 1 } },
      { text: "Rentable rapidement ⚡💰", scores: { visionnaire: 3, ambitieux: 2 } },
    ],
  },
];
